export default {
    actions: {
        save: 'Save',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        delete: 'Delete',
        close: 'Close',
        open: 'Open',
        search: 'Search',
        apply: 'Apply',
        clear: 'Clear',
        edit: 'Edit',
        create: 'Create',
        new: 'New',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        export: 'Export',
        import: 'Import'
    },
    validation: {
        required: 'Required',
        email: 'Invalid email',
        min: 'Minimum {n} characters',
        max: 'Maximum {n} characters'
    },
    confirm: {
        title: 'Are you sure?',
        irreversible: 'This action cannot be undone.'
    },
    pagination: {
        prev: 'Previous',
        next: 'Next',
        rangeOf: '{from}–{to} of {total}',
        range: '{from}–{to}',
        page: 'Page {n}',
        perPage: 'per page'
    },
    errors: {
        generic: 'Unknown error',
        network: 'Network unavailable',
        unauthorized: 'Not authenticated',
        forbidden: 'Permission denied',
        notFound: 'Not found',
        server: 'Server error'
    },
    common: {
        loading: 'Loading…',
        empty: 'Nothing found',
        yes: 'Yes',
        no: 'No'
    },
    theme: {
        label: 'Theme',
        light: 'Light',
        auto: 'Auto',
        dark: 'Dark'
    },
    nav: {
        openMenu: 'Open menu',
        closeMenu: 'Close menu',
        collapseSidebar: 'Hide navigation',
        expandSidebar: 'Show navigation'
    },
    selectedSingular: 'selected',
    selectedPlural: 'selected'
}
